import { SourcingChannelDetails } from 'api-clients/monolith';
import _range from 'lodash/range';
import { FormattedMessage } from 'react-intl';

import { Typography } from '@/components/ui/typography';

import { InactiveChannelCard } from './card';

interface InactiveChannelsProps {
  channels: SourcingChannelDetails[];
  openingId?: string;
  isLoading: boolean;
}

export function InactiveChannels({
  channels,
  openingId,
  isLoading,
}: InactiveChannelsProps) {
  return (
    <>
      <Typography as="h2" variant="caption">
        <FormattedMessage defaultMessage="Other channels" />
      </Typography>
      <div className="flex min-h-[228px] flex-row gap-4 overflow-x-auto whitespace-normal pb-2">
        {isLoading
          ? _range(3).map(index => (
              <InactiveChannelCard.Skeleton key={`skeleton-${index}`} />
            ))
          : channels.map(channel => (
              <InactiveChannelCard
                key={channel.slug}
                channel={channel.slug}
                openingId={openingId}
              />
            ))}
      </div>
    </>
  );
}
